import React, { Component } from 'react';
import { Button, Select, InputNumber, Modal, Radio, Upload, message, Icon, Tooltip, Table, Cascader } from 'antd';
import API_URL from "../../../common/url";
import $, { xToken } from '../../../common/AjaxRequest';
import '../css/style.less';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new'
const RadioGroup = Radio.Group;
const { Option } = Select;

// GP 计算默认表格数据 有盲态、非盲态
const tableDataDefautltByGpBoth = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'visitContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币（盲态）',
        key: 'visitContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币（盲态）',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 11,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 12,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindFteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 13,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 14,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 15,
        name: ''
    }]
// GP 计算默认表格数据 有盲态、非盲态， 建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByGpBothFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币（盲态）',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindFteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindFteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 10,
        name: ''
    }]
// GP 计算默认表格数据 只有盲态或只有非盲态
const tableDataDefautltByGp = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'visitContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币',
        key: 'visitContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 11,
        name: ''
    }]
// GP 计算默认表格数据 只有盲态或只有非盲态， 建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByGpFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteContractUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（不含税）/人民币',
        key: 'fteContractTotalAmountNoTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 6,
        name: ''
    }]
// 总价 计算默认表格数据 有盲态、非盲态
const tableDataDefautltByPriceBoth = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'visitUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'visitGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 11,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 12,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 13,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindTotalPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 14,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindcontractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 15,
        name: ''
    }]
// 总价 计算默认表格数据 有盲态、非盲态，建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByPriceBothFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币（盲态）',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币（盲态）',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '非盲服务报价（只做FTE制）',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币（非盲）',
        key: 'nonBindUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（不含税）/人民币（非盲）',
        key: 'nonBindTotalPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议合同总价（含税6%）/人民币（非盲）',
        key: 'nonBindcontractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 10,
        name: ''
    }]
// 总价 计算默认表格数据 只有盲态或只有非盲态，
const tableDataDefautltByPrice = [{
        id: 1,
        index: 1,
        name: '建议标访报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'visitUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币',
        key: 'visitContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议标准访视单价（不含税）/人民币',
        key: 'visitStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'visitGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 6,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 7,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 8,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 9,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 10,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 11,
        name: ''
    }]
// 总价 计算默认表格数据 只有盲态或只有非盲态，建议底价方式是FTE制，不展示建议标访报价
const tableDataDefautltByPriceFTE = [
    {
        id: 1,
        name: '建议FTE报价',
        value1: '-',
        value2: '-',
        value3: '-',
        value4: '-',
        value5: '-',
    },
    {
        id: 2,
        name: '建议单例价格（不含税）/人民币',
        key: 'fteUnitPrice',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 3,
        name: '建议合同总价（含税6%）/人民币',
        key: 'fteContractTotalAmountTax',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 4,
        name: '建议FTE单价单价（不含税）/人民币',
        key: 'fteStandardAmount',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },
    {
        id: 5,
        name: '建议GP值（%）',
        key: 'fteGp',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
    },{
        id: 6,
        name: ''
    }]
class GPCalculateModal extends Component {
    state = {
        basePriceStatus: '', 
        universalParams: {},
        evaluateRecordId: '',
        parameterValue: null, // GP%默认=参数4
        visible: false,
        loading: false,
        coefficient: 1,
        gpStatus: 'GP',
        gpValue: 0,
        totalPrice: 0,
        serveFeeType: '',
        bindTotalPrice: 0,
        nonBindTotalPrice: 0,
        columns: [{ title: '', dataIndex: 'name', key: 'name', width: 260 }],
        tableData: [],
        count: 0,
        finalPriceStatus: '', 
        finalGp: '', 
        finalGpList: [], 
        evaluateCalcGpDetails: [], // 按GP的原始响应数据数组
        evaluateCalcGpPriceDetails: [], // 按总价的原始响应数据数组
        areaList: [], // 治疗领域
        investigationAreaId: undefined, // 项目领域ID
        diseaseClassList: [], // 疾病分类列表
        diseaseClassId: undefined, // 疾病分类ID
        diseaseClassName: undefined, // 疾病分类名称
        diseaseList: [], // 疾病列表
        diseaseId: undefined, // 疾病ID
        diseaseName: undefined, // 疾病名称
        sourcePath: '',
        researchProductTypeId: undefined, // 研究产品类型ID
        researchProductTypeList: [], // 研究产品类型列表
    }
    // 打开GP测算弹窗 sourcePath: GPtable: GP列表弹窗， FloorPriceModal: 建议底价弹窗
    show = (evaluateRecordId = '', basePriceStatus = '', parameterValue = null, sourcePath) => {
        const { coefficient } = this.state;
        this.setState({
            evaluateRecordId,
            basePriceStatus,
            parameterValue,
            finalPriceStatus: basePriceStatus === 'FTE' ? 'FTE' : '', 
            visible: true,
            gpValue: parameterValue ? parameterValue : 0,
            sourcePath,
        }, async () => {
            if(basePriceStatus === 'FTE') {
                // 研究产品类型选项
                this.queryConfigWithChildByType();
                await this.loadAreaList();
            }
            try {
                // 等待两个异步方法都完成
                await Promise.all([
                    this.loadQueryUniversal(coefficient, evaluateRecordId),
                    this.queryServeFeeType(evaluateRecordId)
                ]);
                // 访视制:弹窗打开时即校验参考单价,避免用户操作完成后才被拦截
                if (basePriceStatus === 'VISIT' && this.state.universalParams.haveEmpCost === false) {
                    message.warning('请联系业务线负责人设置参考单价');
                }
                // 两个方法都完成后调用goAdd
                if(sourcePath === 'FloorPriceModal') {
                    this.goAdd();
                }
            } catch (error) {
                // console.error('数据加载失败:', error);
                // message.error('数据加载失败，请重试');
            }
        });
    }

    // 获取项目服务内容 （盲态、非盲态、盲态和非盲态）
    queryServeFeeType = (evaluateRecordId) => {
        return new Promise((resolve, reject) => {
            const options = {
                method: "POST",
                url: API_URL.evaluate.queryServeFeeType,
                data: { evaluateRecordId },
                dataType: "json",
                doneResult: (res) => {
                    const { serveFeeType } = res;
                    this.setState({
                        serveFeeType,
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            };
            $.sendRequest(options);
        });
    }
    //研究产品类型选项
    queryConfigWithChildByType = () => {
        return new Promise((resolve, reject) => {
            const options = {
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => {
                    const { list = [] } = res;
                    const newList = list.map(el => ({
                        value: el.evaluateConfigureId,
                        code: el.code,
                        label: el.configureValue,
                        children: el.childList.length ? el.childList.map(childData => ({
                            value: childData.evaluateConfigureId,
                            label: childData.configureValue,
                        })) : undefined,
                    }));
                    this.setState({
                        researchProductTypeList: newList || []
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        })
    }
    //获取项目领域、项目分类选项
    loadAreaList = () => {
        return new Promise((resolve, reject) => {
            const options = {
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    this.setState({
                        areaList: res.areaList || []
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        });
    }

    hide = () => {
        this.setState({
            universalParams: {},
            serveFeeType: '', // 项目服务内容 （盲态、非盲态、盲态和非盲态）
            parameterValue: null, // GP%默认=参数4
            visible: false,
            coefficient: 1,
            gpStatus: 'GP',
            gpValue: 0,
            totalPrice: 0,
            bindTotalPrice: 0,
            nonBindTotalPrice: 0,
            columns: [{
                title: '',
                dataIndex: 'name',
                key: 'name',
                width: 260,
            }],
            tableData: [],
            count: 0,
            finalPriceStatus: '', // 最终建议报价方式: 访视制 FTE制
            finalGp: '', // 建议GP值（%）
            finalGpList: [], // 建议GP值（%）列表
            evaluateCalcGpDetails: [], // 按GP
            evaluateCalcGpPriceDetails: [], // 按总价
            areaList: [], // 治疗领域
            investigationAreaId: undefined, // 项目领域ID
            diseaseClassList: [], // 疾病分类列表
            diseaseClassId: undefined, // 疾病分类ID
            diseaseClassName: undefined, // 疾病分类名称
            diseaseList: [], // 疾病列表
            diseaseId: undefined, // 疾病ID
            diseaseName: undefined, // 疾病名称
            sourcePath: '',
        });
    }
    // 获取评估参数
    loadQueryUniversal = (coefficient, evaluateRecordId) => {
        return new Promise((resolve, reject) => {
            const { basePriceStatus, sourcePath } = this.state;
            let data ={
                evaluateRecordId,
            }
            if (basePriceStatus === 'VISIT') {
                data.coefficient = coefficient;
            }
            const options = {
                method: "POST",
                url: sourcePath === 'GPtable' ? API_URL.evaluate.queryParamsForGpSimulationCal : API_URL.evaluate.queryUniversal,
                data,
                dataType: "json",
                doneResult: (res) => {
                    this.setState(
                        {
                            universalParams: {
                                ...res,
                            },
                            columns: [{
                                title: '',
                                dataIndex: 'name',
                                key: 'name',
                                width: 260,
                            }],
                            tableData: [],
                            count: 0,
                            finalGp: '', // 建议GP值（%）
                            finalGpList: [], // 建议GP值（%）列表
                            evaluateCalcGpDetails: [], // 按GP
                            evaluateCalcGpPriceDetails: [], // 按总价
                            researchProductTypeId: res.productTypeParentId == 0 ? [res.researchProductTypeId] : [res.productTypeParentId, res.researchProductTypeId],
                        },
                        () => resolve(res)
                    );
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        });
    }
    //获取参考标准访视单价
    loadStandardVisitAmount = (data) => {
        return new Promise((resolve, reject) => {
            const options = {
                method: 'POST',
                url: API_URL.evaluate.standardVisitAmount,
                data,
                dataType: 'json',
                doneResult: res => {
                    let universalParams = {...this.state.universalParams, ...res};
                    delete universalParams.evaluateStandardVisitUnitPrice;
                    this.setState({
                        universalParams,
                        count: 0,
                        tableData: [],
                        columns: [{
                            title: '',
                            dataIndex: 'name',
                            key: 'name',
                            width: 260,
                        }],
                        // finalPriceStatus: this.state.basePriceStatus === 'FTE' ? 'FTE' : '', // 最终建议报价方式: 访视制 FTE制
                        finalGp: '', // 建议GP值（%）
                        finalGpList: [], // 建议GP值（%）列表
                        evaluateCalcGpDetails: [], // 按GP
                        evaluateCalcGpPriceDetails: [], // 按总价
                    }, () => resolve(res))
                },
                failResult: (err) => {
                    reject(err);
                }
            }
            $.sendRequest(options)
        })
        
    }
    handleChange = (value, key) => {
        const { coefficient, evaluateRecordId, gpStatus, gpValue, basePriceStatus, evaluateCalcGpDetails, evaluateCalcGpPriceDetails, 
            parameterValue, investigationAreaId, diseaseClassId, diseaseId, sourcePath, researchProductTypeId } = this.state;
        switch (key) {
            case 'coefficient':
                // 1. 处理空值情况 (用户删除了输入框内容)
                if (value === null || value === undefined || value === '') {
                    this.setState({ coefficient: null });
                    // 可选：如果要求为空时停止查询或传入默认值(如1)，在此处处理
                    return;
                }
                if(coefficient === value){
                    return;
                }
                this.setState({
                    coefficient: value, 
                }, () => {
                    // 3. 只有当它是一个“完整”的数字时，才触发后端请求
                    const strValue = String(value);
                    
                    // 如果末尾是小数点（如 "33."），说明用户还没输完，不调接口
                    if (strValue.endsWith('.')) {
                        return; 
                    }

                    const numValue = parseFloat(value);
                    if (!isNaN(numValue)) {
                        // 只有是有效数字且输完了（没有以点结尾）才调接口
                        this.loadQueryUniversal(numValue, evaluateRecordId);
                    }
                });
                break;
            case 'gpStatus':
                // GP测算方式
                this.setState({
                    gpStatus: value,
                    gpValue: value === 'GP' ? (parameterValue || 0) : 0,
                    totalPrice: 0,
                    bindTotalPrice: 0,
                    nonBindTotalPrice: 0,
                    count: 0,
                    tableData: [],
                    columns: [{
                        title: '',
                        dataIndex: 'name',
                        key: 'name',
                        width: 260,
                    }],
                    finalPriceStatus: basePriceStatus === 'FTE' ? 'FTE' : '', // 最终建议报价方式: 访视制 FTE制
                    finalGp: '', // 建议GP值（%）
                    finalGpList: [], // 建议GP值（%）列表
                    evaluateCalcGpDetails: [], // 按GP
                    evaluateCalcGpPriceDetails: [], // 按总价
                }, () => {
                    if(value === 'GP' && sourcePath === 'FloorPriceModal'){
                        this.goAdd();
                    }
                })
                break;
            case 'finalPriceStatus':
                // 切换建议报价方式（访视制/FTE制）
                this.setState({
                    finalPriceStatus: value,
                    finalGp: '', // 切换方式后，必须重置已选的最终GP，防止数据错位
                }, () => {
                    // 根据新的最终报价方式，重新从原始数据中提取 GP 列表
                    const dataSource = gpStatus === 'GP' ? evaluateCalcGpDetails : evaluateCalcGpPriceDetails;
                    this.syncFinalGpList(dataSource);
                });
                break;
            case 'researchProductTypeId':
                // 研究产品类型ID
                this.setState({
                    researchProductTypeId: value,
                }, async () => {
                    if(value.length === 0 && !investigationAreaId){
                        await this.loadQueryUniversal(gpValue, evaluateRecordId);
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    }else{
                        await this.loadStandardVisitAmount({
                            researchProductTypeId: value[value.length - 1],
                            investigationAreaId: investigationAreaId || '',
                            diseaseClassId: diseaseClassId || '',
                            diseaseId: diseaseId || '',
                            evaluateRecordId: evaluateRecordId,
                        });
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    }
                })
                break;
            case 'investigationAreaId': 
                this.setState({
                    investigationAreaId: value,
                    diseaseClassList: [],
                    diseaseClassId: undefined,
                    diseaseClassName: undefined,
                    diseaseList: [], // 疾病列表
                    diseaseId: undefined,
                    diseaseName: undefined,
                }, async () => {
                    if(!value){
                        await this.loadQueryUniversal(gpValue, evaluateRecordId);
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    }else{
                        await this.loadStandardVisitAmount({
                            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
                            investigationAreaId: value,
                            evaluateRecordId: evaluateRecordId,
                        });
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    }
                })
                break
            case 'diseaseClassId':
                // 疾病分类ID
                if(JSON.stringify(value) === '{}') {
                    this.setState({
                        diseaseClassId: undefined,
                        diseaseClassName: undefined,
                        diseaseList: [], // 疾病列表
                        diseaseId: undefined,
                        diseaseName: undefined,
                    }, async () => {
                        await this.loadStandardVisitAmount({
                            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
                            investigationAreaId: investigationAreaId,
                            // diseaseClassId: '0',
                            evaluateRecordId: evaluateRecordId,
                        });
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    });
                    
                }else{
                    const { value: id, text } = value;
                    this.setState({
                        diseaseClassId: id,
                        diseaseClassName: text,
                        diseaseList: [], // 疾病列表
                        diseaseId: undefined,
                        diseaseName: undefined,
                    }, async () => {
                        await this.loadStandardVisitAmount({
                            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
                            investigationAreaId: investigationAreaId,
                            diseaseClassId: id,
                            evaluateRecordId: evaluateRecordId,
                        });
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    });
                }
                break;
            case 'diseaseId':
                // 疾病ID
                if(JSON.stringify(value) === '{}') {
                    this.setState({
                        diseaseId: undefined,
                        diseaseName: undefined,
                    }, async () => {
                        await this.loadStandardVisitAmount({
                            investigationAreaId: investigationAreaId,
                            diseaseClassId: diseaseClassId,
                            // diseaseId: '0',
                            evaluateRecordId: evaluateRecordId,
                        });
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    });
                }else{
                    const { value: id, text } = value;
                    this.setState({
                        diseaseId: id,
                        diseaseName: text,
                    }, async () => {
                        await this.loadStandardVisitAmount({
                            researchProductTypeId: researchProductTypeId[researchProductTypeId.length - 1],
                            investigationAreaId: investigationAreaId,
                            diseaseClassId: diseaseClassId,
                            diseaseId: id,
                            evaluateRecordId: evaluateRecordId,
                        });
                        if(gpStatus === 'GP' && sourcePath === 'FloorPriceModal') {
                            this.goAdd();
                        }
                    });
                }
                break;
            default:
                this.setState({ [key]: value })
                break;
        }
    }
    // 添加列
    goAdd = () => {
        const { 
            evaluateRecordId, 
            universalParams: {
                evaluateStandardVisitAmount, 
                evaluateFte, 
                laborCostPerFte='', 
                laborCostPerVisit='', 
                parameterFirst='', 
                parameterSecond='', 
                parameterThird='', 
                parameterFourth=''
            }, 
            serveFeeType, 
            gpStatus, 
            gpValue, 
            totalPrice, 
            basePriceStatus,
            bindTotalPrice,
            nonBindTotalPrice,
            count,
            evaluateCalcGpDetails,
            evaluateCalcGpPriceDetails,
        } = this.state;

        if (count >= 5) return message.warning('最多支持添加5列计算');

        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";

        let url, data;
        if(gpStatus === 'GP'){
            url = isBindAndNonBind ? API_URL.evaluate.calculateGpByGpBoth : API_URL.evaluate.calculateGpByGp;
            data = { evaluateRecordId, evaluateFte, gpValue, laborCostPerFte, laborCostPerVisit, parameterFirst, parameterSecond, parameterThird, parameterFourth };
            if (isBindAndNonBind) data.basePriceStatus = basePriceStatus;
            if (basePriceStatus === 'VISIT') data.evaluateStandardVisitAmount = evaluateStandardVisitAmount || 0;
        } else {
            url = isBindAndNonBind ? API_URL.evaluate.calculateGpByPriceBoth : API_URL.evaluate.calculateGpByPrice;
            data = { evaluateRecordId, laborCostPerFte, laborCostPerVisit, parameterFirst, parameterSecond, parameterThird, parameterFourth };
            if (isBindAndNonBind) {
                data.bindTotalPrice = bindTotalPrice;
                data.nonBindTotalPrice = nonBindTotalPrice;
                data.basePriceStatus = basePriceStatus;
            } else {
                data.totalPrice = totalPrice;
                data.evaluateFte = evaluateFte;
            }
            if(basePriceStatus === 'VISIT') data.evaluateStandardVisitAmount = evaluateStandardVisitAmount || 0;
        }

        $.sendRequest({
            method: "POST",
            url,
            data,
            dataType: "json",
            doneResult: (res) => {
                // 将新数据存入对应的原始数组
                if (gpStatus === 'GP') {
                    const newItem = { ...res, gpValue }; // 记录当时的GP值用于标题显示
                    this.setState({ evaluateCalcGpDetails: [...evaluateCalcGpDetails, newItem] }, () => this.rebuildTable());
                } else {
                    const newItem = { ...res, bindPrice: isBindAndNonBind ? bindTotalPrice : totalPrice, nonBindPrice: nonBindTotalPrice };
                    this.setState({ evaluateCalcGpPriceDetails: [...evaluateCalcGpPriceDetails, newItem] }, () => this.rebuildTable());
                }
            },
        });
    }

    // 【核心改动】删除列：直接操作数据源数组
    handleDeleteColumn = (index) => {
        const { gpStatus, evaluateCalcGpDetails, evaluateCalcGpPriceDetails } = this.state;
        
        // 索引是从1开始的，对应数组下标 index-1
        if (gpStatus === 'GP') {
            const newList = [...evaluateCalcGpDetails];
            newList.splice(index - 1, 1);
            this.setState({ evaluateCalcGpDetails: newList, finalGp: '' }, () => this.rebuildTable());
        } else {
            const newList = [...evaluateCalcGpPriceDetails];
            newList.splice(index - 1, 1);
            this.setState({ evaluateCalcGpPriceDetails: newList, finalGp: '' }, () => this.rebuildTable());
        }
        message.success('删除成功');
    }

    // 【核心重构】全量重绘表格方法
    rebuildTable = () => {
        const { gpStatus, evaluateCalcGpDetails, evaluateCalcGpPriceDetails, serveFeeType, basePriceStatus } = this.state;
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";
        
        // 1. 确定数据源
        const dataSource = gpStatus === 'GP' ? evaluateCalcGpDetails : evaluateCalcGpPriceDetails;
        
        // 2. 初始化列头
        let newColumns = [{ title: '', dataIndex: 'name', key: 'name', width: 260 }];
        
        // 3. 确定并深拷贝表格模版
        let template;
        if (gpStatus === 'GP') {
            if (isBindAndNonBind) {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByGpBothFTE : tableDataDefautltByGpBoth;
            } else {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByGpFTE : tableDataDefautltByGp;
            }
        } else {
            if (isBindAndNonBind) {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByPriceBothFTE : tableDataDefautltByPriceBoth;
            } else {
                template = basePriceStatus === 'FTE' ? tableDataDefautltByPriceFTE : tableDataDefautltByPrice;
            }
        }
        let newTableData = JSON.parse(JSON.stringify(template));

        // 4. 根据数据源动态构建每一列
        dataSource.forEach((dataItem, idx) => {
            const currentCount = idx + 1;
            const dataIndex = 'value' + currentCount;

            // 构建标题
            let title;
            if (gpStatus === 'GP') {
                title = `GP%=${dataItem.gpValue}%`;
            } else if (!isBindAndNonBind) {
                title = `总价=${(dataItem.bindPrice || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`;
            } else {
                const total = Number(((dataItem.bindPrice || 0) + (dataItem.nonBindPrice || 0)).toFixed(2));
                title = `总价=${total.toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`;
            }

            // 添加列定义
            newColumns.push({
                title,
                dataIndex,
                key: dataIndex,
                width: 120,
                className: 'text-center',
                render: (text, record) => {
                    const isLastRow = record.id === newTableData[newTableData.length - 1].id;
                    if (isLastRow) {
                        return <a onClick={() => this.handleDeleteColumn(currentCount)}>删除</a>;
                    }
                    if (text === undefined || text === '' || text === '-') return text || 0;
                    if (record.name && record.name.includes('人民币')) {
                        const num = Number(text);
                        // 如果数值是整数，则不显示小数位；否则显示两位小数
                        if (Number.isInteger(num)) {
                            return num.toLocaleString('zh-CN');
                        } else {
                            return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        }
                    }
                    if (record.name && record.name.includes('（%）')) {
                        return text + '%';
                    }
                    return text;
                }
            });

            // 填充数据到模版行中
            newTableData.forEach(row => {
                if (row.key && dataItem[row.key] !== undefined) {
                    row[dataIndex] = dataItem[row.key] || 0;
                }
            });
        });

        // 5. 更新状态并刷新下拉列表
        this.setState({
            columns: newColumns,
            tableData: dataSource.length === 0 ? [] : newTableData,
            count: dataSource.length
        }, () => {
            this.syncFinalGpList(dataSource);
        });
    }

    // 同步最终GP下拉框列表
    syncFinalGpList = (dataSource) => {
        const { gpStatus, finalPriceStatus } = this.state;
        
        // 如果没有数据，直接清空列表
        if (!dataSource || dataSource.length === 0) {
            this.setState({ finalGpList: [] });
            return;
        }

        let newFinalGpList = [];

        dataSource.forEach((item, index) => {
            if (gpStatus === 'GP') {
                // 模式1：按GP%测算。GP值是用户输入时确定的 (item.gpValue)
                newFinalGpList.push({
                    key: `gp_col_${index}`,
                    value: item.gpValue,
                });
            } else {
                // 模式2：按总价测算。GP值是由后端计算出的 (visitGp 或 fteGp)
                // 根据当前选中的“最终建议报价方式”来决定取哪个字段
                let targetGpValue = '-';
                if (finalPriceStatus === 'VISIT') {
                    targetGpValue = item.visitGp;
                } else if (finalPriceStatus === 'FTE') {
                    targetGpValue = item.fteGp;
                }

                // 只有当有有效数值时才加入下拉框
                if (targetGpValue !== undefined && targetGpValue !== null && targetGpValue !== '-') {
                    newFinalGpList.push({
                        key: `price_col_${index}`,
                        value: targetGpValue,
                    });
                }
            }
        });

        this.setState({ finalGpList: newFinalGpList });
    }

    // ... (submit 方法中也需要做适配修改) ...
    sumbit = () => {
        const {
            serveFeeType, evaluateRecordId, universalParams, coefficient, gpStatus,
            basePriceStatus, count, finalPriceStatus, finalGp, finalGpList,
            evaluateCalcGpDetails, evaluateCalcGpPriceDetails,
            researchProductTypeId, investigationAreaId, diseaseClassId, diseaseId,
        } = this.state;
        if (!coefficient) return message.warning('请输入难度系数');
        if (count === 0) return message.warning('请添加测试情况');
        if (!finalPriceStatus) return message.warning('请选择最终建议报价方式');
        if (!finalGp) return message.warning('请选择最终GP%');
        // 未查询到参考单价(EmpCost)时不允许提交
        if (universalParams.haveEmpCost === false) {
            return message.warning(basePriceStatus === 'FTE' ? '请重新设置参考FTE单价' : '请联系业务线负责人设置参考单价');
        }

        const selectedGpItem = finalGpList.find(item => item.key === finalGp);
        const finalGpValue = selectedGpItem ? selectedGpItem.value : 0;
        
        // 获取选中那一列在原始数组中的索引
        const finalIndex = finalGpList.findIndex(item => item.key === finalGp);

        let data = {
            evaluateRecordId,
            basePriceStatus,
            coefficient: basePriceStatus === 'VISIT' ? coefficient : 0,
            ...universalParams, // 解构参数
            gpStatus,
            finalPriceStatus,
            finalGp: finalGpValue,
        };

        // 按照后端要求的格式构造数据
        if(gpStatus === 'GP'){
            evaluateCalcGpDetails.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    data[`evaluateCalcGpDetails[${index}].${key}`] = item[key];
                });
            });
        } else {
            evaluateCalcGpPriceDetails.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    data[`evaluateCalcGpPriceDetails[${index}].${key}`] = item[key];
                });
            });
        }

        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.confirmGp,
            data,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false });
                
                // 计算回传给父组件的单价
                let unitPrice = 0, nonBindUnitPrice = 0;
                const source = gpStatus === 'GP' ? evaluateCalcGpDetails[finalIndex] : evaluateCalcGpPriceDetails[finalIndex];
                if (source) {
                    const isFTE = finalPriceStatus === 'FTE';
                    if (gpStatus === 'GP') {
                        unitPrice = isFTE ? source.fteContractUnitPrice : source.visitContractUnitPrice;
                        nonBindUnitPrice = source.nonBindFteContractUnitPrice;
                    } else {
                        unitPrice = isFTE ? source.fteUnitPrice : source.visitUnitPrice;
                        nonBindUnitPrice = source.nonBindUnitPrice;
                    }
                }
                // 一口价(FTE制):把GP测算页面选择的参考单价维度带给建议底价弹窗,随建议底价提交时保存(研究产品类型为级联数组,取末级)
                let submitUniversalParams = { ...universalParams };
                if (basePriceStatus === 'FTE') {
                    submitUniversalParams.researchProductTypeId = researchProductTypeId && researchProductTypeId.length ? researchProductTypeId[researchProductTypeId.length - 1] : 0;
                    submitUniversalParams.investigationAreaId = investigationAreaId || 0;
                    submitUniversalParams.diseaseClassId = diseaseClassId || 0;
                    submitUniversalParams.diseaseId = diseaseId || 0;
                }
                this.props.gpCalcuationSubmit(finalGpValue, unitPrice || 0, nonBindUnitPrice || 0, res.evaluateCalcGpId, submitUniversalParams);
                this.hide();
            }
        });
    }

    render() {
        const { 
            visible, universalParams, loading, coefficient, gpStatus, gpValue, totalPrice, 
            serveFeeType, bindTotalPrice, nonBindTotalPrice, basePriceStatus, tableData, 
            count, columns, finalPriceStatus, finalGp, finalGpList, areaList, 
            investigationAreaId, diseaseClassId, diseaseClassName, diseaseId, diseaseName, sourcePath, researchProductTypeId, researchProductTypeList } = this.state;
        const {evaluateFte, evaluateNum, evaluateStandardVisitAmount, researchCycle, invNum, planRandomSiteRate, visitRatioFte} = universalParams
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        let areaOption = areaList.map(el => ({ label: el.investigationAreaName, value: el.investigationAreaId }))
        // areaOption.push({ label: '-', value: 0 }); //治疗领域
        return (
            <Modal
                title="GP 测算"
                visible={visible}
                onOk={this.sumbit}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width={1000}
                bodyStyle={{
                    minHeight: 750
                }}
                {...(sourcePath === 'GPtable' ? { footer: null } : {})}
            >
                <div className="cont-cont">
                    <ul className="preview-list">
                        <li>
                            <div >建议底价方式：{basePriceStatus === 'VISIT' ? '访视制' : 'FTE制'}</div>
                        </li>
                        <li className="title"><h4>1.评估参数</h4></li>
                        {
                            basePriceStatus === 'VISIT' && (
                                <li>
                                    <div className="item">
                                        <label className="ui-label">{asterisk}难度系数</label>
                                        <span className="" style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip title="难度系数只适用访视评估">
                                                <Icon type="exclamation-circle" style={{ marginRight: 5, color: '#108ee9' }} />
                                            </Tooltip>
                                            {
                                                <InputNumber 
                                                    min={0}                // 难度系数通常不为负数
                                                    precision={2}          // 强制保留两位小数
                                                    step={0.01}            // 步长
                                                    placeholder='请输入'
                                                    style={{ width: 120 }}
                                                    value={coefficient}    // 这里的 coefficient 建议初始值为 1 或 null
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} // 千分位展示
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    onChange={value => this.handleChange(value, 'coefficient')}
                                                />
                                            }
                                        </span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">评估例数</label>
                                        <span className="">{evaluateNum}</span>
                                    </div>
                                </li>
                            )
                        }
                        {
                            basePriceStatus === 'VISIT' && (
                                <li>
                                    <div className="item">
                                        <label className="ui-label">评估标访数（*难度）</label>
                                        <span className="">{evaluateStandardVisitAmount}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">评估FTE数</label>
                                        <span className="">{evaluateFte}</span>
                                    </div>
                                </li>
                            )
                        }
                        {
                            basePriceStatus === 'FTE' && (
                                <li>
                                    <div className="item">
                                        <label className="ui-label">评估例数</label>
                                        <span className="">{evaluateNum}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">评估FTE数</label>
                                        <span className="">{evaluateFte}</span>
                                    </div>
                                </li>
                            )
                        }
                        <li>
                            <div className="item">
                                <label className="ui-label">研究周期</label>
                                <span className="">{researchCycle} 月</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">参与计算的项目数量</label>
                                <span className="">{invNum}</span>
                            </div>
                        </li>
                        <li>
                            <div className="item">
                                <label className="ui-label">入组数/中心数</label>
                                <span className="">{planRandomSiteRate}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">单位FTE标准访视数</label>
                                <span className="">{visitRatioFte}</span>
                            </div>
                        </li>
                        {
                            basePriceStatus === 'FTE' && sourcePath === 'FloorPriceModal' && (
                                <li className="title"><h4>2.FTE单价</h4></li>
                            )
                        }
                        {
                            basePriceStatus === 'FTE' && sourcePath === 'FloorPriceModal' && (
                                <li>
                                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                        <label className="ui-label">参考FTE单价</label>
                                        <span className="">
                                            <Cascader 
                                                options={researchProductTypeList} 
                                                placeholder="请选择研究产品类型"
                                                style={{ width: 140 }}
                                                allowClear={false}
                                                value={researchProductTypeId}
                                                onChange={value => this.handleChange(value, 'researchProductTypeId')}
                                            />
                                            <Select 
                                                style={{ width: 120 }}
                                                value={investigationAreaId}
                                                showSearch={true}
                                                allowClear={true}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                placeholder='请选择项目领域'
                                                onChange={value => this.handleChange(value, 'investigationAreaId')}
                                            >
                                                {areaOption.map(el => (
                                                    <Option disabled={el.disabled} key={el.value} value={String(el.value)}>{el.label}</Option>
                                                ))}
                                            </Select>
                                            <SearchRetrieve
                                                value={diseaseClassName}
                                                name="diseaseClassId"
                                                showName="diseaseClassName"
                                                style={{ width: 120 }}
                                                keyword="keyword"
                                                placeholder="请选择疾病分类"
                                                disabled={!investigationAreaId || investigationAreaId==='0'}
                                                params={{limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined}}
                                                url={API_URL.common.queryDiseaseClassByAreaId}
                                                config={{ id: 'diseaseClassId', name: 'diseaseClassName'}}
                                                // extraOption={[{ label: '-', value: 0 }]}
                                                onChange={value => this.handleChange(value, 'diseaseClassId')}
                                            />
                                            <SearchRetrieve
                                                value={diseaseName}
                                                name="diseaseId"
                                                showName="diseaseName"
                                                style={{ width: 120 }}
                                                keyword="keyword"
                                                placeholder="请选择疾病"
                                                disabled={!diseaseClassId || diseaseClassId==='0' || !investigationAreaId || investigationAreaId==='0'}
                                                params={{limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined, diseaseClassId: diseaseClassId ? diseaseClassId : undefined}}
                                                url={API_URL.common.queryAllDisease}
                                                config={{ id: 'diseaseId', name: 'diseaseName'}}
                                                // extraOption={[{ label: '-', value: 0 }]}
                                                onChange={value => this.handleChange(value, 'diseaseId')}
                                            />
                                        </span>
                                    </div>
                                </li>
                            )
                        }
                        {
                            (sourcePath === 'GPtable' || sourcePath === 'FloorPriceModal') && (
                                <li className="title">
                                    <h4>
                                        {sourcePath === 'GPtable' ? '2' : (basePriceStatus === 'VISIT' ? '2' : '3')}.测算情况
                                    </h4>
                                </li>
                            )
                        }
                        <li>
                            <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                <label className="ui-label">GP测算方式</label>
                                <span className="">
                                    <RadioGroup 
                                        value={gpStatus}
                                        onChange={e => this.handleChange(e.target.value, 'gpStatus')} 
                                    >
                                        <Radio value='GP' style={{ marginRight: 20 }}>按GP%</Radio>
                                        <Radio value='PRICE'>按总价</Radio>
                                    </RadioGroup>
                                </span>
                            </div>
                        </li>
                        {
                            gpStatus == 'GP' && (
                                <li>
                                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                        <label className="ui-label">GP%</label>
                                        <span className="" style={{ marginRight: 5 }}>
                                            <InputNumber 
                                                precision={2}
                                                step={0.01}
                                                placeholder='请输入'
                                                style={{ width: 120 }}
                                                value={gpValue}
                                                defaultValue={1}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                onChange={value => this.handleChange(value, 'gpValue')}
                                            />
                                        </span>
                                        <Button type="primary" onClick={this.goAdd}>添加</Button>
                                    </div>
                                </li>
                            )
                        }
                        {
                            gpStatus == 'PRICE' && isBindAndNonBind && (
                                <li>
                                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                        <label className="ui-label">盲态总价金额</label>
                                        <span className="" style={{ marginRight: 5 }}>
                                            <InputNumber 
                                                min={0}
                                                precision={2}
                                                step={0.01}
                                                placeholder='请输入'
                                                style={{ width: 120 }}
                                                value={bindTotalPrice}
                                                defaultValue={1}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                onChange={value => this.handleChange(value, 'bindTotalPrice')}
                                            />
                                            <span>（不含税）/人民币</span>
                                        </span>
                                        <label style={{ marginLeft: 20 }}>非盲总价金额：</label>
                                        <span className="" style={{ marginRight: 5 }}>
                                            <InputNumber 
                                                min={0}
                                                precision={2}
                                                step={0.01}
                                                placeholder='请输入'
                                                style={{ width: 120 }}
                                                value={nonBindTotalPrice}
                                                defaultValue={1}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                onChange={value => this.handleChange(value, 'nonBindTotalPrice')}
                                            />
                                            <span>（不含税）/人民币</span>
                                        </span>
                                        <Button type="primary" onClick={this.goAdd}>添加</Button>
                                    </div>
                                </li>
                            )
                        }
                        {
                            gpStatus == 'PRICE' && (isNonBind || isBind) && (
                                <li>
                                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                        <label className="ui-label">总价金额</label>
                                        <span className="" style={{ marginRight: 5 }}>
                                            <InputNumber 
                                                min={0}
                                                precision={2}
                                                step={0.01}
                                                placeholder='请输入'
                                                style={{ width: 120 }}
                                                value={totalPrice}
                                                defaultValue={1}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                onChange={value => this.handleChange(value, 'totalPrice')}
                                            />
                                            <span>（不含税）/人民币</span>
                                        </span>
                                        <Button type="primary" onClick={this.goAdd}>添加</Button>
                                    </div>
                                </li>
                            )
                        }
                        <li>
                            <div style={{ marginBottom: 10 }}></div>
                            <TableC
                                className={count > 0 ? 'calculateTable' : ''}
                                data={tableData}
                                loading={loading}
                                rowKey={'id'}
                                columns={columns}
                                pagination={false}
                                showUnderline={false}
                            />
                        </li>
                        {
                            sourcePath === 'FloorPriceModal' && (
                                <li className="title"><h4>3.最终GP测算</h4></li>
                            )
                        }
                        {
                            sourcePath === 'FloorPriceModal' && (
                                <li>
                                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                        <label className="ui-label">{asterisk}最终建议报价方式</label>
                                        <span className="">
                                            <RadioGroup
                                                value={finalPriceStatus}
                                                onChange={e => this.handleChange(e.target.value, 'finalPriceStatus')} 
                                            >
                                                {basePriceStatus !== 'FTE' && <Radio value='VISIT' style={{ marginRight: 20 }}>访视制</Radio>}
                                                <Radio value='FTE'>FTE制</Radio>
                                            </RadioGroup>
                                        </span>
                                    </div>
                                </li>
                            )
                        }
                        {
                            sourcePath === 'FloorPriceModal' && (
                                <li>
                                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                        <label className="ui-label">{asterisk}最终GP%</label>
                                        <span className="">
                                            <Select 
                                                value={finalGp} 
                                                disabled={count === 0 || (gpStatus == 'PRICE' && !finalPriceStatus)} 
                                                style={{width: 120}} onChange={value => this.handleChange(value, 'finalGp')}
                                                placeholder='请选择'
                                            >
                                                {finalGpList.map((item) => (
                                                    <Option key={item.key} value={item.key}>{item.value}</Option>
                                                ))}
                                            </Select>
                                        </span>
                                    </div>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default GPCalculateModal;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/GPCalculateModal.js